<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>İdeal çəki kalkulyatoru</h1>
      </div>

      <div class="col-12">
        <div class="note">
          <p>Bədənin Kütlə İndeksi (BKİ) 1869 ildə belçikalı alim Adolf Ketle tərəfindən insan bədəninin çəkisini qiymətləndirmək üçün yaradılmışdır. Ümumdünya Səhiyyə Təşkilatına görə 18,50 kq/m² və 24,99 kq/m² arasında yerləşən BKİ qiyməti normal çəkinin olmasını göstərilir.</p>
        </div>
      </div>

      <div class="col-12">
        <h3>Kalkulyatora öz fərdi dəyərlərinizi qeyd edərək BKİ nəticənizi öyrənə bilərsiniz:</h3>
      </div>

      <div class="col-md-4">
        <p>Boyunuz, sm:</p>
        <input type="number" v-model="height" @input="calc">
      </div>
      <div class="col-md-4">
        <p>Çəkiniz, kq:</p>
        <input type="number" v-model="mass" @input="calc">
      </div>
      <div class="col-md-4">
        <p>BKİ, kq/m²:</p>
        <input type="text" v-model="bki" disabled>
      </div>
      

      <div class="col-12">
        <transition tag="div" name="fade" mode="out-in" >
          <div class="note" v-html="info" v-show="info.length > 0"></div>
        </transition>
      </div>

      <div class="col-12">
        <div class="note">
          <p>BKİ - bədən çəkisinin göstəricisini (kq-la) boyun göstəricisinin (metrlə) kvadratına bölməklə hesablanır.</p>
          <p>BKİ göstəriciləri aşağıdakı şəxslər üçün məqbul sayılmır:</p>
          <ul>
            <li>boy inkişafı qurtarmamış uşaqlar;</li>
            <li>güclü inkişaf etmiş əzələlərə malik şəxslər (idmançılar);</li>
            <li>hamilə qadınlar.</li>
          </ul>
          <p>Artiq çəki və piylənmə bir çox xəstəliklərin yaranmasına gətirib çixara bilər: ürək-damar sistemi xəstəlikləri, şəkərli diabet, varikoz xəstəliyi, oynaq xəstəlikləri, öd daşı xəstəliyi, onkoloji xəstəliklər, cinsi pozğunluqlar, sonsuzluq və sairə.</p>
        </div>
      </div>

    </div>
  </div>
</template>

<script> 
  export default {
    data(){
      return {
        mass: '',
        height: '',
        bki: '',
        info: '',
        status: [
          '<h3>Həddən artıq arıq.</h3> <p>İdmanla məşğul olub, qida dəyəri yüksək olan məhsullardan istifadə edin.</p>',
          '<h3>Yüngül səviyyədə arıqlıq.</h3> <p>İdmanla məşğul olub, qida dəyəri yüksək olan məhsullardan istifadə edin.</p>',
          '<h3>Normal bədən çəkisi.</h3> <p>Düzgün qidalanma və fiziki aktivliklə bu çəkiniz qorumağa çalışın.</p>',
          '<h3>Bədən çəkisinin artıqlığı.</h3> <p>Daha çox hərəkət etməyə çalışın, idmanla məşğul olun.</p>',
          '<h3>I dərəcəli piylənmə.</h3> <p>Daha çox hərəkət etməyə çalışın, gimnastika ilə məşğul olun.</p>',
          '<h3>II dərəcəli piylənmə.</h3> <p>Daha çox hərəkət etməyə çalışın, gimnastika ilə məşğul olun.</p>',
          '<h3>III dərəcəli piylənmə.</h3> <p>Daha çox hərəkət etməyə çalışın, gimnastika ilə məşğul olun.</p>'
        ]
      }
    },
    methods: {
      calc: function(){
        if(this.mass.length > 1 && this.height.length > 2){

          this.bki = (this.mass / (this.height/100 * this.height/100)).toFixed(2);
       
          switch(true) {
            case(this.bki <= 16) : this.info = this.status[0];
            break;
            case(this.bki > 16 && this.bki <= 18.5) : this.info = this.status[1];
            break;
            case(this.bki > 18.5 && this.bki <= 24.99) : this.info = this.status[2];
            break;
            case(this.bki > 25 && this.bki <= 29.99) : this.info = this.status[3];
            break;
            case(this.bki > 30 && this.bki <= 34.99) : this.info = this.status[4];
            break;
            case(this.bki > 35 && this.bki <= 39.99) : this.info = this.status[5];
            break;
            case(this.bki >= 40) : this.info = this.status.obeseClass3;
            break;
          }

        }
      }
    }
  }
</script>

<style scoped>

  
</style>


// WEBPACK FOOTER //
// src/components/calc/Bodymass.vue